import EditableItemList from "../../../../../components/editableItemList/EditableItemList";
import { IDocument } from "../../../../../models/document";
import DocumentItemListItem from "./DocumentItemListItem";

interface DocumentItemListProps {
  items: IDocument[];
  onAdd: () => void;
  onEdit: (item: IDocument) => void;
  onDelete: (id: string) => void;
}

const DocumentItemList = (props: DocumentItemListProps) => {
  const { items, onAdd, onEdit, onDelete } = props;

  return (
    <EditableItemList listCount={items.length} onAdd={onAdd}>
      {items.map((item) => (
        <DocumentItemListItem
          key={item.id}
          documentItem={item}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </EditableItemList>
  );
};

export default DocumentItemList;
